import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import {
  BaseWebsocketMessage,
  GetWebsocketMessageRequest,
  QueryWebsocketMessageRequest,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { BackendResponse, Customer, Person } from '@qtek/shared/models';
import { getGMTOffset } from '@qtek/shared/utils';
import { Observable } from 'rxjs';
import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class CustomersService extends HttpEntityManager<Customer, Customer> {
  protected http = inject(HttpClient);
  private websocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'RelationshipContact';
  wsManager = new WSEntityManager(this.websocketService, this.entityName);

  constructor() {
    super();
  }

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity(payload, true);
  }

  query(payload: Omit<QueryWebsocketMessageRequest, 'ent' | 'op'>): void {
    this.wsManager.query(payload);
  }

  createCustomer(payload: Customer) {
    return super.post(payload, undefined, {
      gmtOffset: getGMTOffset(),
      tzGuess: btoa(Intl.DateTimeFormat().resolvedOptions().timeZone),
    });
  }

  deleteCustomerInfo(relId: string) {
    return super.delete(relId, {
      tp: 'val',
    });
  }

  deleteCustomer(relId: string) {
    return super.delete(relId, {
      tp: 'force',
    });
  }

  removeCustomer(relId: string) {
    return this.http.delete<BackendResponse>(
      `/api/v2/model/RelationshipContact/${relId}`,
      {
        ...this.baseRequestOptions,
      }
    );
  }

  updateCustomer(payload: Customer | Person, relId: string) {
    return super.put(payload, relId);
  }

  updateInstitution(payload: Partial<Customer>) {
    return super.put(payload);
  }

  subscribeSingleContactById(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity(payload, false);
  }

  getSingleContactById(
    payload: Omit<GetWebsocketMessageRequest, 'ent' | 'op'>
  ) {
    this.wsManager.get(payload);
  }
}
